import type { User } from '@supabase/supabase-js';
import { supabase } from './supabaseClient';

// Production-ready HubSpot integration test using server-side API
export const testHubSpotProductionIntegration = async (user: User) => {
  // This control is an intentional, user-triggered Preview-only acceptance test.
  // Never allow the button to write to the production CRM from the production UI.
  if (!window.location.hostname.endsWith('.review-lab-optimax.pages.dev')) {
    return { success: false, error: 'The manual integration test is limited to Cloudflare Preview.' };
  }
  const { data: { session }, error: sessionError } = await supabase.auth.getSession();
  if (sessionError || !session?.access_token || session.user.id !== user.id) {
    return { success: false, error: 'Please sign in with your internal OG01.io test account.' };
  }
  try {
    const response = await fetch('/api/hubspot-sync', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({})
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || !result.success) {
      return { success: false, error: result.error || `HubSpot sync failed (HTTP ${response.status})` };
    }
    return {
      success: true,
      hubspotId: result.hubspotId,
      data: {
        message: 'Verified HubSpot contact sync succeeded.',
        action: result.action,
        hubspotId: result.hubspotId,
        timestamp: new Date().toISOString()
      }
    };
  } catch {
    return { success: false, error: 'Unable to contact the server-side CRM endpoint.' };
  }
};

// Check if production API is available
export const checkProductionAPIAvailability = async () => {
  try {
    const response = await fetch('/api/hubspot-sync', {
      method: 'HEAD' // Just check if endpoint exists
    });
    
    return {
      available: response.status !== 404,
      status: response.status
    };
  } catch {
    return {
      available: false,
      status: null
    };
  }
}; 